import React, { useEffect, useState } from 'react';
import { useWallet, detectWallets } from '../hooks/useWallet';
import { NET } from '../config';

// Wallet picker: injected providers only (Binance Wallet, MetaMask, OKX, Rabby). Used for staking, claims, repair, market.
export default function ConnectModal() {
  const { connectOpen, setConnectOpen, connectWith } = useWallet();
  const [list, setList] = useState([]);
  const [busy, setBusy] = useState('');
  useEffect(() => {
    if (!connectOpen) return undefined;
    setList(detectWallets());
    const t = setTimeout(() => setList(detectWallets()), 300); // late EIP-6963 announcements
    const onKey = (e) => { if (e.key === 'Escape') setConnectOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => { clearTimeout(t); window.removeEventListener('keydown', onKey); };
  }, [connectOpen, setConnectOpen]);
  if (!connectOpen) return null;
  const none = list.length > 0 && !list.some((w) => w.detected);
  return (
    <div className="cm-overlay" data-testid="connect-modal" onClick={() => setConnectOpen(false)}>
      <div className="cm-box" onClick={(e) => e.stopPropagation()}>
        <div className="cm-head"><h3>Connect wallet</h3><button className="cm-x" onClick={() => setConnectOpen(false)}>✕</button></div>
        <p className="cm-sub">For staking, claiming, repair and the marketplace. {NET.label}.</p>
        {list.map((w) => (
          <button key={w.id} className={`cm-wallet${w.detected ? '' : ' off'}`} data-testid={`wallet-${w.id}`} disabled={!!busy}
            onClick={async () => { if (!w.detected) { window.open(w.install, '_blank', 'noopener'); return; } setBusy(w.id); await connectWith(w); setBusy(''); }}>
            {w.iconUrl ? <img src={w.iconUrl} alt="" /> : <span className="cm-ico">{w.icon}</span>}
            <span className="cm-name">{w.name}</span>
            <span className="cm-tag">{busy === w.id ? 'Connecting…' : w.detected ? 'Detected' : 'Install ↗'}</span>
          </button>
        ))}
        {none && <p className="cm-note">No browser wallet detected. Install one of the wallets above, then reload. Or let your AI agent mint for you (🤖 on the Mint page).</p>}
      </div>
    </div>
  );
}
